import { IconButton, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { getActasCsvHandler } from "../../handlers/actas.handler";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { Spinner } from "react-bootstrap";


const ExcelFront = ({ headers, filename, estados, filterFields, actasLocale,data }) => {

    const [actasCsv, setActasCsv] = useState();
    const { loads } = useGeneralAppStore();


    return (
        <Tooltip title="Descargar tabla" arrow>
            <>
                    <div className="h-100 d-flex align-items-center" >
                        <CSVLink
                            style={{ textDecoration: "none" }}
                            headers={headers}
                            filename={filename}
                            data={data}
                            separator={";"}
                        // disabled={loads?.includes("actas")}
                        >
                            <IconButton>
                                <img
                                    src="https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png"
                                    alt="excel"
                                    style={{ height: 25 }}
                                />
                            </IconButton>
                        </CSVLink>
                    </div>
            </>
        </Tooltip>
    );
}
export default ExcelFront;